import React from 'react'
import PropTypes from 'prop-types'
import About from './About'
import './Navbar.css'
export default function Navbar(props) {
  return (
    <>
      <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
        <div className="container-fluid">
          <a className="navbar-brand" href="#">{props.title}</a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="/">Home</a>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={props.showAbout()} >About</button>
              </li>

            </ul>
            {/* <form className="d-flex" role="search">
              <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
              <button className="btn btn-outline-success" type="submit">Search</button>
            </form> */}

            <label className="switch mx-2" >
              <input type="checkbox" onClick={props.toggelMode} />
              <span className="slider"></span>
            </label>

          </div>
        </div>
      </nav>
      {props.about && (
        <About />
      )}
    </>
  )
}

Navbar.propTypes = {
  title: PropTypes.string.isRequired
}